import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import CTASection from "@/components/CTASection";
import CarrierGrid, { CarrierMarquee } from "@/components/CarrierGrid";
import { CARRIER_DISCLOSURE } from "@/data/siteContent";

export default function Carriers() {
  return (
    <>
      <SEO
        title="Insurance Carriers We Work With | 1907 Insurance Group"
        description="1907 Insurance Group compares life insurance options from established carriers. Availability varies by state, product, and eligibility."
      />
      <PageHero
        eyebrow="Insurance Carriers"
        title="Why the Company Behind the Policy Matters"
        intro="Every insurance company evaluates age, health, and medications differently. Comparing carriers is often the difference between a policy that fits and one that doesn't."
      />
      <CarrierMarquee />
      <section className="py-16 md:py-24" data-testid="carriers-list">
        <div className="container-site">
          <Reveal>
            <h2 className="text-3xl sm:text-4xl tracking-tight">Coverage Options From Established Insurance Companies</h2>
            <p className="mt-5 max-w-3xl text-lg text-mutedink leading-relaxed">
              Below are the carriers 1907 Insurance Group works with. Rather than recommend a company from a webpage,
              Michael matches options to your situation after a short conversation — because underwriting, pricing,
              and product availability differ from one carrier to the next.
            </p>
          </Reveal>
          <div className="mt-12">
            <CarrierGrid showNotes />
          </div>
          <Reveal>
            <div className="mt-14 max-w-3xl rounded-xl border border-navy-100 bg-white p-8 shadow-sm" data-testid="carrier-explainer">
              <h3 className="text-2xl">What to Know About Carrier Choice</h3>
              <ul className="mt-5 list-disc space-y-3 pl-6 text-mutedink leading-relaxed">
                <li>Two carriers can price the same person very differently.</li>
                <li>Some carriers are more flexible about specific health conditions than others.</li>
                <li>Benefit types differ — level from day one versus graded for the first few years.</li>
                <li>Not every product is available in every state or for every applicant.</li>
              </ul>
              <p className="mt-6 text-sm text-mutedink leading-relaxed">{CARRIER_DISCLOSURE}</p>
            </div>
          </Reveal>
        </div>
      </section>
      <CTASection heading="Let Michael Do the Comparing for You" text="Share a few basics, and Michael will review which carriers and products may fit your age, health, state, and budget." />
    </>
  );
}
